import { lazy } from "react";
import type { SolutionRoute } from "../routes";
import type { SolutionSettings } from "../settings";
import type { NavItem } from "../../nav";
import { Icon } from "../../ui";

const CollectionsPage = lazy(() => import("./collections").then((m) => ({ default: m.CollectionsPage })));
const CustomerPage = lazy(() => import("./customers").then((m) => ({ default: m.CustomerPage })));
const CustomersPage = lazy(() => import("./customers").then((m) => ({ default: m.CustomersPage })));
const DiscountPage = lazy(() => import("./discounts").then((m) => ({ default: m.DiscountPage })));
const DiscountsPage = lazy(() => import("./discounts").then((m) => ({ default: m.DiscountsPage })));
const InventoryPage = lazy(() => import("./inventory").then((m) => ({ default: m.InventoryPage })));
const OrderPage = lazy(() => import("./orders").then((m) => ({ default: m.OrderPage })));
const OrdersPage = lazy(() => import("./orders").then((m) => ({ default: m.OrdersPage })));
const ProductPage = lazy(() => import("./product").then((m) => ({ default: m.ProductPage })));
const ProductsPage = lazy(() => import("./products").then((m) => ({ default: m.ProductsPage })));
const ShopSettings = lazy(() => import("./settings").then((m) => ({ default: m.ShopSettings })));
const ReviewsPage = lazy(() => import("./reviews").then((m) => ({ default: m.ReviewsPage })));
const AbandonedCartsPage = lazy(() => import("./carts").then((m) => ({ default: m.AbandonedCartsPage })));

/** Shop: products, collections, inventory, orders, abandoned carts, customers, reviews and discount codes, sold on the members' site. */

export const routes: SolutionRoute[] = [
  { solution: "shop", path: "orders", element: <OrdersPage /> },
  { solution: "shop", path: "orders/:id", element: <OrderPage /> },
  { solution: "shop", path: "products", element: <ProductsPage /> },
  { solution: "shop", path: "products/:id", element: <ProductPage /> },
  { solution: "shop", path: "collections", element: <CollectionsPage /> },
  { solution: "shop", path: "inventory", element: <InventoryPage /> },
  { solution: "shop", path: "customers", element: <CustomersPage /> },
  { solution: "shop", path: "customers/guest/:email", element: <CustomerPage /> },
  { solution: "shop", path: "customers/:id", element: <CustomerPage /> },
  { solution: "shop", path: "discounts", element: <DiscountsPage /> },
  { solution: "shop", path: "discounts/:id", element: <DiscountPage /> },
  { solution: "shop", path: "reviews", element: <ReviewsPage /> },
  { solution: "shop", path: "abandoned-carts", element: <AbandonedCartsPage /> },
];

export const settings: SolutionSettings[] = [{ solution: "shop", key: "shop", label: "Shop", icon: Icon.tag, need: "shop.view", Component: ShopSettings }];

export const nav: NavItem = {
  to: "/orders",
  label: "Shop",
  icon: Icon.tag,
  solution: "shop",
  need: "shop.view",
  also: ["/products", "/collections", "/inventory", "/customers", "/discounts", "/abandoned-carts", "/reviews"],
  subs: [
    { to: "/orders", label: "Orders" },
    { to: "/abandoned-carts", label: "Abandoned carts" },
    { to: "/products", label: "Products" },
    { to: "/collections", label: "Collections" },
    { to: "/inventory", label: "Inventory" },
    { to: "/customers", label: "Customers" },
    { to: "/reviews", label: "Reviews" },
    { to: "/discounts", label: "Discounts" },
  ],
};
